import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Bitcoin100000 = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">Bitcoin Surpasses $100,000 for the First Time
          Following Pro-Crypto SEC Chair Appointment by Trump</h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/navnews/bitcoin.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Bitcoin Hits $100,000 Milestone Amid Optimism in Crypto Markets
              Bitcoin reached a historic milestone, surpassing $100,000 for the
              first time in its history. This landmark achievement highlights
              the growing confidence of investors in a more crypto-friendly
              regulatory environment under the incoming administration of Donald
              Trump, who recently won the US Presidential elections. The
              cryptocurrency has more than doubled in value since the beginning
              of 2024 and surged by 45% in just the last four weeks following
              Trump’s election victory. As of 0240 GMT on Thursday, Bitcoin was
              trading at $100,027, up 2.2% from the previous session, after
              briefly hitting a high of $100,277 earlier in the day. <h1>Trump’s
              Influence on Crypto Markets </h1>  Investor optimism has been fueled by
              Trump’s apparent support for the cryptocurrency sector. His
              administration has proposed the formation of a crypto advisory
              council, with companies like Ripple, Kraken, and Circle vying for
              a spot. This council is expected to play a key role in shaping the
              overhaul of U.S. cryptocurrency regulations. Adding to the
              excitement, Trump’s personal foray into the crypto world has
              further boosted market confidence. In September, he launched a
              crypto venture called World Liberty Financial, although specific
              details about its operations remain scarce. Additionally, reports
              suggest Trump Media and Technology Group is in advanced talks to
              acquire the crypto trading platform Bakkt. <h1> Key Drivers of
              Bitcoin’s Surge </h1> The approval of U.S.-listed Bitcoin
              exchange-traded funds (ETFs) earlier this year has been a major
              catalyst for Bitcoin’s rise. These ETFs, which were previously
              blocked by the SEC due to investor protection concerns, have
              opened the market to a wider audience, including institutional
              investors. Since the election, over $4 billion has flowed into
              these funds. The Bitcoin rally has also boosted related
              industries. Shares of MARA Holdings, a leading Bitcoin mining
              company, have jumped 65% in November alone. Meanwhile, options
              trading on BlackRock’s Bitcoin ETF has seen significant activity,
              with call options—bets on further price increases—outnumbering put
              options by 22 to 1. <h1> Caution Amid the Celebration </h1> While Bitcoin’s
              milestone is being celebrated, critics continue to voice concerns
              about the sector’s energy consumption and past controversies. The
              collapse of the FTX exchange two years ago and the subsequent
              conviction of its founder, Sam Bankman-Fried, remain a blemish on
              the industry’s reputation. Market analysts are also urging caution
              regarding potential volatility. Steven McClurg, founder of Canary
              Capital, warned, “Investors may look to take profits after this
              milestone, leading to short-term dips. However, once these sell
              orders are cleared, Bitcoin could rise even further, potentially
              reaching $120,000 by Christmas.”
            </p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
